import React from "react";
import "./PlantDisplay.css";

// Helper to get emoji and status
function getPlantStatus(moisture, tooWet, tooDry, raw) {
  const isTooWet = raw ? moisture < tooWet : moisture > tooWet;
  const isTooDry = raw ? moisture > tooDry : moisture < tooDry;
  if (isTooWet) {
    return { emoji: "🌊", status: "Too wet!" };
  } else if (isTooDry) {
    return { emoji: "🏜️", status: "Too dry!" };
  } else {
    return { emoji: "🌱", status: "Perfect!" };
  }
}

function PlantDisplay({ viewMode, data = [], tooWet, tooDry, raw }) {
  // Precompute status for each plant
  const plantRows = data.map((moisture, idx) => {
    if (moisture === undefined || moisture === null) return null;
    const sensorId = idx + 1;
    const { emoji, status } = getPlantStatus(moisture, tooWet, tooDry, raw);
    return { sensorId, moisture, emoji, status };
  }).filter(Boolean);

  if (viewMode === "table") {
    return (
      <div className="plantsTableWrapper">
        <table className="plantsTable">
          <thead>
            <tr>
              <th>Plant</th>
              <th>Status</th>
              <th>Sensor Value</th>
            </tr>
          </thead>
          <tbody>
            {plantRows.map(({ sensorId, moisture, emoji }) => (
              <tr key={sensorId}>
                <td>Plant {sensorId}</td>
                <td>
                  <div style={{ fontSize: "2em", lineHeight: "1" }}>{emoji}</div>
                </td>
                <td>{moisture}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  // "box" mode
  return (
    <div className="plantsContainer">
      {plantRows.map(({ sensorId, moisture, emoji, status }) => (
        <div className="box" key={sensorId}>
          <h3>Plant {sensorId}</h3>
          <div className="plant">{emoji}</div>
          <div className="statusText">{status}</div>
          <p className="sensorValue">
            Sensor: {moisture}
          </p>
        </div>
      ))}
    </div>
  );
}

export default PlantDisplay;
